export default __webpack_public_path__ + "static/media/left-test.e58f9ba8.png";